(function() {
  var StepHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepHandler = App.loadClass('grower::handlers/placement/StepHandler');

  exports.RadioButtonsHandler = (function(superClass) {
    extend(RadioButtonsHandler, superClass);

    function RadioButtonsHandler() {
      return RadioButtonsHandler.__super__.constructor.apply(this, arguments);
    }

    RadioButtonsHandler.prototype.inputSel = 'button.spp-radio-button';

    RadioButtonsHandler.prototype.addValidationRules = function() {
      return this.validator.registerRule({
        selector: '.validate-radio-button',
        text: '%s requires input',
        func: (function(_this) {
          return function(elem) {
            var aspectID, el, group;
            el = $(elem);
            aspectID = el.attr('data-aspect');
            group = _this.getInputEl({
              aspect: aspectID
            });
            return !!group.filter('.active').length;
          };
        })(this)
      });
    };

    RadioButtonsHandler.prototype.getFieldAspect = function(fieldID, aspectID) {
      var optionID, optionName, optionValue, retval, selectedOption;
      selectedOption = this.getInputEl({
        aspect: aspectID
      }).filter('.active');
      optionValue = selectedOption.attr('data-value') ? parseInt(selectedOption.attr('data-value')) : null;
      optionID = selectedOption.attr('data-option') != null ? parseInt(selectedOption.attr('data-option')) : null;
      optionName = this.taffyObjects.options({
        id: optionID
      }).select('display_name')[0];
      retval = {
        value: optionValue,
        options_id: optionID,
        option_name: optionName
      };
      return retval;
    };

    RadioButtonsHandler.prototype.setFieldAspect = function(fieldAspect) {
      var input;
      if (fieldAspect.options_id) {
        input = this.getInputEl({
          aspect: fieldAspect.aspects_id,
          option: fieldAspect.options_id
        });
        return input.addClass('active');
      }
    };

    RadioButtonsHandler.prototype.afterLoadLayout = function(sel, data) {
      var step;
      RadioButtonsHandler.__super__.afterLoadLayout.call(this, sel, data);
      step = this;
      return this.getInputEl().on('click', function() {
        var el, oldEl;
        el = $(this);
        oldEl = step.getInputEl({
          aspect: el.attr('data-aspect')
        }).filter('.active');
        if (oldEl[0] !== this) {
          oldEl.removeClass('active');
          el.addClass('active');
          oldEl.trigger('change');
          el.trigger('change');
        }
        return false;
      });
    };

    return RadioButtonsHandler;

  })(StepHandler);

}).call(this);
